{
  "CustomisePopupTitle": "Customise Administrator Role",
  "FooterActionsSubmit": "Submit",
  "FooterActionsCancel": "Cancel",
  "FooterActionsHelp": "Help?",
  "TableHeadingAdminAccess": "Administration Access",
  "HeadingAdministrate": "Administrate",
  "HeadingView": "View",
  "HeadingAdd": "Add",
  "HeadingModify": "Change",
  "HeadingDelete": "Delete",
  "EntryCme": "CME Management",
  "EntryCrm": "CRM Management",
  "EntryClientConfig": "Client Configuration",
  "Policy": "Policy",
  "EntryDevices": "Devices",
  "EntryDevicesSub": "(Extensions / Groups / Other Devices)",
  "EntryAgents": "Agents",
  "EntryDirectory": "Directories",
  "EntryApplicationUsers": "Application Users",
  "EntryCodes": "Codes",
  "EntryTelServers": "Telephony Servers",
  "EntryPartition": "Partitions",
  "EntryRecordings": "Recording",
  "EntryMessages": "Messages",
  "EntryDatabase": "Database",
  "EntryUserRole": "User Roles",
  "TableHeadingStatusTools": "Status & Tools Access",
  "HeadingSection": "Section",
  "EntryLicences": "Licenses",
  "EntryLogging": "Logging",
  "EntryLogManagement": "Log Management",
  "EntryAuditTrail": "Audit Trail",
  "EntryTelephoneModuleStatus": "Telephone Module Status",
  "EntryCallControl": "Call Control",
  "EntryServerStatus": "Server Status",
  "TableHeadingActions": "Actions",
  "HeadingAction": "Action",
  "HeadingAllowed": "Allowed",
  "EntryCopyReportsTo": "Copy Reports To...",
  "EntrySignInAs": "Sign in as...",
  "EntryBillingFilesDownload": "Billing CDRs",
  "EntryBillingSummary": "Billing Summary",
  "EntryChangeLicenceLevel": "Change License Level",
  "EntryChangeTelephonyServerBillingStatus": "Change Telephony Server Billing Status",
  "SyncPartition": "Sync Partition",
  "EntryLogFilesDownload": "Download Log Files",
  "TelSysSyncRestrictions": "Change Maximum Sync Parameters",
  "CMEBrandingConfig": "CME Branding Config",
  "EditOwnCMEDomainProfile": "Edit Own CME Domain Profile",
  "EditOwnCMEBranding": "Edit Own CME Branding",
  "EditOwnCMEProvisioning": "Edit Own CME Provisioning",
  "CrmTemplateManage": "CRM Template Management",
  "ViewChangedWarning": "Without the View option, {} can only be {} using the API.",
  "Update": "updated",
  "Delete": "deleted",
  "ViewChangeOr": " or ",
  "NAME": "CustomiseRole",
  "CustomiseRole_Add": "added",
  "EptAccess": "Easy Provisioning Tool"
}
